<template>
  <a-config-provider :locale="locale">
    <router-view/>
    <!-- 全局放入tips提示的元素 需要使用的地方不需要引用了 -->
    <div class="error_tips">
      <span class="error_tips__icon"></span>
      <div class="error_tips__content"></div>
    </div>
  </a-config-provider>
</template>
<script lang="ts">
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { defineComponent } from 'vue';
export default defineComponent({
  setup() {
      return {
        dayjs,
        locale: zhCN,
      };
    },
});
</script>
<style lang="stylus">
#app {
  width: 100%;
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nprogress .bar {
  background: #e2e2e2 !important;
}

.error_tips {
  opacity: 0;
  position: fixed;
  font-size: 12px;
  top: 0;
  left: 0;
  max-width: 250px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  z-index: 9999999;
  pointer-events: none;
  padding: 5px;
  .error_tips__icon {
    position: absolute;
    left: 0;
    bottom: -8px;
    content: '';
    width: 0;
    height: 0;
    border-top: 8px solid rgba(0, 0, 0, 0.5);
    border-right: 8px solid transparent;
    border-left: 8px solid transparent;
  }
}
</style>
